import { getAnalyticsTrackerId } from './features/configuration/selectors';


const identityTracker = (location) => {};


const googleAnalyticsTracker = (trackerId) => {
  if (!window.ga) {
    throw new Error('Could not create analytics tracker');
  }

  window.ga('create', trackerId, 'auto');

  return (location) => {
    window.ga('set', 'page', location.pathname + location.search);
    window.ga('send', 'pageview', location.pathname + location.search);
  };
};


const configureAnalytics = (store) => {
  const trackerId = getAnalyticsTrackerId(store.getState());

  if (trackerId === null) {
    /* eslint-disable no-console */
    console.warn('Failed to fetch analytics tracker ID. Using identity tracker');
    /* eslint-enable no-console */

    return identityTracker;
  }

  return googleAnalyticsTracker(trackerId);
};


export default configureAnalytics;
